'use strict';

angular.module('userRequestEditControllers')

.controller('WithBusinessTaskConflictController', ['$scope', '$state', 'editAccessRequestService', function ($scope, $state, service) {

    // Get by system role (from) 
    $scope.byFromSystemRoles = _.groupBy($scope.validationMessages.BusinessTaskConflictInRequests,
                                         'FromSystemRoleID');

    $scope.trackingOnConflict = function (conflict) {
        return [conflict.FromBusinessTaskID,
                conflict.FromSystemRoleID,
                conflict.ToBusinessTaskID,
                conflict.ToSystemRoleID];
    }

    // To remove conflict
    $scope.removeConflict = function (systemRoleId) {

        service.systemRolePendings.removeConflict($scope.userRequest.UserAccessRequestID, systemRoleId)
        .then(function (updatedSystemRole) {
            if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

            $state.reload();
        });
    }

    // To add authorization exception
    $scope.expirationMaxDate = moment().add(1, 'years').calendar();

    $scope.addAuthorizationException = function (conflict, conflicts, isValid) {
        if (isValid) {
            var requestId = this.userRequest.UserAccessRequestID;
            var systemRoleId = conflict.FromSystemRoleID;

            var now = moment();
            var expirationDateObj = moment(this.exceptionExpirationDate);

            var completeJustification = 'The employee has a task conflict between : ' +
                                        '"' + conflict.FromBusinessTaskName + '" (Role ' + conflict.FromSystemRoleName + ' in ' + conflict.FromBusinessSystemName + ')' +
                                        '\nAND\n' +
                                        '"' + conflict.ToBusinessTaskName + '" (Role ' + conflict.ToSystemRoleName + ' in ' + conflict.ToBusinessSystemName + ')' +
                                        '\n' +
                                        now.format('YYYY-MM-DD') +
                                        ' - Exception by ' + this.authenticatedUser.IdentityName +
                                        ' valid until ' + expirationDateObj.format('MMMM DD, YYYY') + ': ' +
                                        '\n' +
                                        this.exceptionJustification;
            service.systemRolePendings.addAuthorizationExceptionForConflict(requestId, conflicts,
                                                                            completeJustification,
                                                                            this.exceptionExpirationDate)
            .then(function () {
                $state.reload();
            });
        }
    }
}]);